export const commonFormStylesIdentifier = 'g-CommonFormStyles';
export const commonPageStylesIdentifier = 'g-CommonPageStyles';
export const scrollPixelValue = 75;
